import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { createTitle } from "@/functions/createTitle";

export default function JobsPage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps({}) {
  const title = "Find a Job";

  return {
    props: {
      meta: { title: createTitle(title) },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: { items: [{ label: title, href: getRoute("jobs") }] },
        },
        {
          component: "Header",
          props: {
            title: { path: "page.jobs.component.Header.title", placeholder: title },
            description: { path: "page.jobs.component.Header.description" },
          },
        },
        { component: "JobsFeed" },
      ],
    },
  };
}
